/* stylelint-disable-next-line plugin/no-unsupported-browser-features */
/* Do not use this */
/* Use this */
go-nav-list {
  --nav-list-header-padding: var(--go-base-spacing) 0;
  --nav-list-margin: 0;
  --nav-list-header-color: var(--go-color-text);
  /**
    @prop --nav-list-header-fs:
    Font size of nav list header
    - default: 1rem
  */
  --nav-list-header-fs: 1rem;
  /**
    @prop --nav-list-header-fw:
    Font weight of nav list header
    - default: 500
  */
  --nav-list-header-fw: 500;
  /**
    @prop --nav-list-header-gap:
    Gap between nav list header and list items
    - default: 1em
  */
  --nav-list-header-gap: 1em;
  display: inline-block;
  margin: var(--nav-list-margin);
}
go-nav-list[block] {
  display: block;
}
go-nav-list :where([slot=header]) {
  font-size: var(--nav-list-header-fs);
  font-weight: var(--nav-list-header-fw);
  color: var(--nav-list-header-color);
  margin-bottom: var(--nav-list-header-gap);
}
go-nav-list .nav-list-header-text {
  display: flex;
  line-height: 1.5;
  padding: var(--nav-list-header-padding);
}
go-nav-list .nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
go-nav-list .nav-list .nav-list {
  margin-left: 0.5rem;
  padding-left: 0.5rem;
}
go-nav-list .nav-list .nav-item-link {
  font-size: 1em;
  line-height: 1.5;
}